import { ChangeDetectionStrategy, Component } from '@angular/core';

import { EpcotConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { editBetStateSelector } from '../../../types/selectors';
import { IEditMyBetState } from '../../state';
import { EditBetAddPicksContainerComponent } from './edit-bet-add-picks-container.component';

/**
 * A component that holds the picks which should be added in Edit Bet - Desktop view.
 */
@Component({
    selector: 'bs-edit-bet-add-picks-container-desktop',
    templateUrl: './edit-bet-add-picks-container-desktop.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrls: ['./edit-bet-add-picks-container-desktop.scss'],
    standalone: false,
})
export class EditBetAddPicksContainerDesktopComponent extends EditBetAddPicksContainerComponent {
    override editMyBetState$: Observable<IEditMyBetState>;

    constructor(
        public override siteCore: Sitecore,
        store: Store<IBetslipRootState>,
        epcotConfig: EpcotConfig,
    ) {
        super(siteCore, store, epcotConfig);
        this.editMyBetState$ = store.select(editBetStateSelector);
    }
}
